$(document).ready(function() {
  $('.info-steps-activity').tooltip();
  $(".steps_activity_chart").each(function(){
    steps_activity_chart($(this)[0]);
  });
});

function round_scale(x) {
  return Math.ceil(x / 1000) * 1000;
}

function steps_activity_chart(element){

  var ctx = element

  var data = $(".steps_activity_data").data("chart");
  var fontSize;

  if(data.labels.length > 11) {
    // safari requires 0.01
    fontSize = 0.01;
  } else {
    fontSize = 10;
  }

  var yMax;

  var d = data.datasets.map(function(dataset){ return dataset.data }).flat();

  yMax = Math.max.apply(Math, d) * 1.5;

  if(yMax == 0) { yMax = 20000;}


  var my_steps_activity_chart = new Chart(ctx, {
    type: 'bar',
    data: data,

    options: {
      // tooltips: {
      //   enabled: false
      // },
      plugins: {
        labels: {
          fontColor: '#000',
          fontSize: fontSize,
          render: 'value'
        }
      },
      scales: {
          yAxes: [{
              ticks: {
                  min: 0,
                  max: round_scale(yMax),
                  stepSize: (round_scale(yMax))/5
              }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
          }],
      },
      legend: {
        display: false
      }
    }
  });
}